import { writable } from 'svelte/store';

const DEFAULT_TITLE = 'Untitled document';

/**
 * Store for tracking document metadata, primarily the document title
 * extracted from the title block in the spec editor
 */
function createDocumentMetadataStore() {
    const { subscribe, set } = writable({
        title: DEFAULT_TITLE,
        hasCustomTitle: false
    });

    /**
     * Capitalizes the first letter of a string and lowercases the rest
     * @param {string} str - The string to transform
     * @returns {string} The transformed string
     */
    function capitalizeFirst(str) {
        if (!str) return str;
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    return {
        subscribe,
        
        /**
         * Update the document title
         * @param {string|null} title - The new title, or null to reset to default
         */
        setTitle(title) {
            if (title && title.trim()) {
                // Capitalize first letter, lowercase the rest for browser tab
                const formattedTitle = capitalizeFirst(title.trim());
                set({
                    title: formattedTitle,
                    hasCustomTitle: true
                });
            } else {
                set({
                    title: DEFAULT_TITLE,
                    hasCustomTitle: false
                });
            }
        },
        
        /**
         * Reset to default title
         */
        reset() {
            set({
                title: DEFAULT_TITLE,
                hasCustomTitle: false
            });
        }
    };
}

export const documentMetadataStore = createDocumentMetadataStore();